import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import UserSelection from "../components/UserSelection";
import { Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DateTimePicker from "react-datetime-picker";
import { DateTime } from "luxon";
import { ButtonModalFormSaveClose } from "../components/ButtonModalSelection";
import { AxisLineSeparator } from "../components/AxisLineSeparator";
import AxisSpinner from "../components/AxisSpinner";

const MessageCreation = ({ onComplete, close = null, refresh = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const [isPush, setIsPush] = useState(true);
  const [expiryDate, setExpiryDate] = useState(new Date());
  const [selectNotificationFilter, setSelectNotificationFilter] =
    useState("User");
  const [errorTitle, setErrorTitle] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorUser, setErrorUser] = useState(false);
  const [userSelect, setUserSelect] = useState(null);
  const [sendDisabled, setSendDisabled] = useState(false);

  const userMessageLabel = "User";
  const allUsersMessageLabel = "All Users";
  const axisStaffMessageLabel = "Axis Staff";
  const everyoneMessageLabel = "Everyone";
  const [messageType, setMessageType] = useState("GENERAL");

  const isEmptyOrSpaces = (str) => {
    return str === null || str.trim() === "";
  };

  const hasUser = (user) => user !== undefined && user !== null;

  useEffect(() => {
    if (selectNotificationFilter !== "User") setUserSelect(null);
  }, [selectNotificationFilter]);

  useEffect(() => {
    setErrorTitle(isEmptyOrSpaces(title));
    setErrorMessage(isEmptyOrSpaces(messageBody));
    if (selectNotificationFilter === "User") setErrorUser(!hasUser(userSelect));
  }, [title, messageBody, userSelect]);

  useEffect(() => {
    if (expiryDate === null || expiryDate === null) return;

    var lastMidNight = new Date();
    lastMidNight.setHours(0, 0, 0, 0);
    console.log(lastMidNight);
    console.log("expiry date", expiryDate);
    console.log(expiryDate - lastMidNight);
    const isPastDate = expiryDate - lastMidNight < 0;
    if (isPastDate) setExpiryDate(lastMidNight);
  }, [expiryDate]);

  useEffect(() => {
    var valid = errorTitle === false && errorMessage === false;
    if (selectNotificationFilter === "User")
      valid = valid && errorUser === false;

    setSendDisabled(!valid);
  }, [errorUser, errorMessage, errorTitle, selectNotificationFilter]);

  const getFilterButton = (name) => {
    return (
      <Button
        className={"w-100 font-weight-bold mb-2"}
        onClick={() => {
          setSelectNotificationFilter(name);
        }}
        variant={selectNotificationFilter === name ? "offblack" : "secondary"}
      >
        {name}
      </Button>
    );
  };

  const onSend = async (e) => {
    e.preventDefault();
    var expiryString = DateTime.fromJSDate(expiryDate)
      .plus({ days: 1 })
      .toISODate();
    var params = {
      expiry: expiryString,
      type: messageType,
    };
    const notificationMessage = {
      title: title,
      body: messageBody,
      sendPush: isPush,
    };

    var requestURL = null;
    if (selectNotificationFilter === userMessageLabel) {
      requestURL = "/api/admin/user_push_notification";
      params.user_id = userSelect?.id;
    } else if (selectNotificationFilter === allUsersMessageLabel) {
      requestURL = "/api/admin/users_push_notification";
    } else if (selectNotificationFilter === axisStaffMessageLabel) {
      requestURL = "/api/admin/staff_push_notification";
    } else if (selectNotificationFilter === everyoneMessageLabel) {
      requestURL = "/api/admin/global_push_notification";
    } else {
      console.log("Invalid selection");
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        params: params,
      };
      const response = await authAxios().post(
        requestURL,
        notificationMessage,
        config,
      );
      setLoading(false);
      if (onComplete !== null && onComplete !== undefined) onComplete();
      if (refresh !== null) refresh();
    } catch (e) {
      console.log("error: ", e);
    }
  };

  const messageTypeChanged = (value) => {
    var text = value.target.value;
    setMessageType(text);
  };

  const displayMessageForm = () => {
    return (
      <Fragment>
        <Form noValidate onSubmit={onSend} id="message-form">
          <Row className={"mb-3"}>
            <Form.Group
              className={"w-100"}
              style={
                selectNotificationFilter !== "User" ? { display: "None" } : null
              }
              as={Col}
              accessKey={"formUserSelection"}
            >
              <Form.Control
                as={UserSelection}
                defaultValue={userSelect}
                onSelected={setUserSelect}
                placeholderText={"Select User"}
                isInvalid={errorUser}
              />
              <Form.Control.Feedback type={"invalid"}>
                Need to enter target user for message
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="formExpiryDateSelection"
              as={Col}
            >
              <Row>
                <Form.Label as={Col} xs="auto">
                  Expiry
                </Form.Label>
                <Col>
                  <Form.Control
                    style={{ borderBlockColor: "red" }}
                    as={DateTimePicker}
                    minDate={new Date()}
                    format={"dd/MM/yyyy"}
                    onChange={(value) => {
                      setExpiryDate(value);
                    }}
                    value={expiryDate}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>
          </Row>
          <AxisLineSeparator />
          <Form.Group className={"mb-3"} as={Col} controlId={"formTitle"}>
            <Form.Label>Message Title:</Form.Label>
            <Form.Control
              onChange={(e) => {
                setTitle(e.currentTarget.value);
              }}
              isInvalid={errorTitle}
              required
            />
            <Form.Control.Feedback type={"invalid"}>
              Needs to have a title
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className={"mb-3 w-50"} as={Row} controlId={"formType"}>
            <Col>
              <Form.Label>Message Type:</Form.Label>
            </Col>
            <Col>
              <Form.Select value={messageType} onChange={messageTypeChanged}>
                <option value="GENERAL">General</option>
                <option value="URGENT">Urgent</option>
                <option value="BLOCK_BOOKING">Block Booking</option>
              </Form.Select>
            </Col>
          </Form.Group>

          <Form.Group className={"mb-3"} as={Col} controlId={"formMessage"}>
            <Form.Label>Message Body:</Form.Label>
            <Form.Control
              as={"textarea"}
              style={{ height: "10em" }}
              onChange={(e) => {
                setMessageBody(e.currentTarget.value);
              }}
              isInvalid={errorMessage}
              required
            />
            <Form.Control.Feedback type={"invalid"}>
              Needs to have a message
            </Form.Control.Feedback>
          </Form.Group>
          <Col className={"mb-3 d-flex justify-content-end"}>
            <Form.Check
              className={"fs-4"}
              type={"checkbox"}
              label={"Send as push notification"}
              checked={isPush}
              onChange={(e) => {
                setIsPush(!isPush);
              }}
            />
          </Col>
        </Form>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Container fluid className={"m-0 p-0"}>
        <h4 className={"text-axis-offblack"}>Select Target Audience</h4>
        <Row>
          <Col>{getFilterButton(userMessageLabel)}</Col>
          <Col>{getFilterButton(allUsersMessageLabel)}</Col>
          <Col>{getFilterButton(axisStaffMessageLabel)}</Col>
          <Col>{getFilterButton(everyoneMessageLabel)}</Col>
        </Row>
      </Container>

      <Container fluid className={"m-0 p-0"}>
        {displayMessageForm()}
      </Container>

      {loading ? <AxisSpinner loading={loading} /> : null}

      <ButtonModalFormSaveClose
        saveName={"Send"}
        formSave={onSend}
        close={close}
        loading={loading}
      />
    </Fragment>
  );
};

export default MessageCreation;
